import { isAnyOf } from "@reduxjs/toolkit";

import { startAppListening } from "../../listener";
import { themeActions } from "./slice";
import { PluginContextType } from "../plugin/types";
import { accountStateSelector } from '../account/api';

export const autoSaveThemes = (pluginContext: PluginContextType) => {
  return startAppListening({
    matcher: isAnyOf(
      themeActions.saveTheme,
      //themeActions.deleteTheme,
      themeActions.bulkImport
    ),
    effect: (_, api) => {
      const state = api.getState();
      const accountState = accountStateSelector(state);

      if (accountState.data?.id) {
        const themes = state.themes;
        if (Object.values(themes).length > 0) {
          pluginContext.saveThemes(accountState.data.id, themes);
        }
      }
    }
  });
};
